export default {
  methods: {
    showAlert(message, type, action) {
      bus.$emit('newToastMessage', message, type, action);
    },
  },
};
